import { render, staticRenderFns } from "./PurchaseOrderListItem.vue?vue&type=template&id=19f81b83&scoped=true&"
import script from "./PurchaseOrderListItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f81b83",
  null
  
)

export default component.exports